import React from 'react'
import { Col, Row } from 'antd'
import UsersCard from './list/UsersCard'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'

const UsersSection = () => {
    useDocumentTitle('Users')

    return (
        <Row gutter={[24, 24]}>
            <Col span={24}>
                <UsersCard />
            </Col>
        </Row>
    )
}

export default UsersSection
